import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@shared/api/client';
import { DateRange } from '@shared/components/DateRangeFilter';

export interface SponsorsAnalyticsDto {
  // T-155 — sponsorId null = riga aggregata "Senza partner".
  sponsors: Array<{
    sponsorId: string | null;
    name: string;
    receiptCount: number;
    uniqueFans: number;
  }>;
  timeline: Array<{ date: string; sponsorId: string; count: number }>;
}

export function useAnalyticsSponsors(range: DateRange) {
  const [from, to] = range;
  return useQuery({
    queryKey: ['analytics', 'sponsors', from.toISOString(), to.toISOString()],
    queryFn: async () => {
      const res = await apiClient.get<SponsorsAnalyticsDto>('/analytics/sponsors', {
        params: { from: from.toISOString(), to: to.toISOString() },
      });
      return res.data;
    },
  });
}
